export default "__VITE_ASSET__CnCvxRsX__"